
import { Component, Vue } from 'vue-property-decorator'
import { updateInfo } from '@/apis/myInfo/myInfo'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import i18n from '@/lang';

@Component({})
export default class NameAndDepart extends Vue {
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  private title: string = ''
  private stnoNumber: any = ''
  private warnInfo: string = '0'
  private warnOn: boolean = false //控制警示信息显隐
  // 监听输入
  change() {
    // @TODO: 这里的正则匹配是什么???
    // this.stnoNumber = this.stnoNumber.replace(/[^\u4E00-\u9FA5\,，.]/g, '')
    // if (this.stnoNumber.length > 12) {
    //   this.stnoNumber = this.stnoNumber.slice(0, 12)
    // }
  }
  //院系或者班级
  deparentCalss() {
    this.stnoNumber = this.stnoNumber.replace(/[^\u4E00-\u9FA5\,，.()（）\a-zA-Z0-9]/g, '')
    if (this.stnoNumber.length > 20) {
      this.stnoNumber = this.stnoNumber.slice(0, 20)
    }
  }

  keep() {
    if (this.stnoNumber.length < 2 && this.stnoNumber.length > 0) {
      this.warnInfo = i18n.t('ktpMy.请输入正确的') + this.title
      this.warnOn = true
    } else if (this.stnoNumber.length == 0) {
      this.warnInfo = this.title + i18n.t('ktpMy.不能为空')
      this.warnOn = true
    } else {
      this.warnOn = false
      //进行保存操作
      if (this.$route.query.modify == 'name') {
        updateInfo({
          username: this.stnoNumber,
          school: this.userInfo.school,
          department: this.userInfo.department,
          teachcourse: this.userInfo.teachcourse,
          stno: this.userInfo.stno,
          majors: this.userInfo.majors,
          classno: this.userInfo.additionInfo?.classno ?? '',
          enrolltime: this.userInfo.additionInfo?.enrolltime ?? '',
          grade: this.userInfo.additionInfo?.grade ?? '',
          // classno: this.userInfo.additionInfo!.classno,
          // enrolltime: this.userInfo.additionInfo!.enrolltime,
          // grade: this.userInfo.additionInfo!.grade,
        })
          .then((res) => {
            this.$store.dispatch('setUserInfo').then(() => {
              this.$router.back()
            })
          })
          .catch((e) => {})
      } else if (this.$route.query.modify == 'depart') {
        updateInfo({
          username: this.userInfo.username,
          school: this.userInfo.school,
          department: this.stnoNumber,
          teachcourse: this.userInfo.teachcourse,
          stno: this.userInfo.stno,
          majors: this.userInfo.majors,
          classno: this.userInfo.additionInfo?.classno ?? '',
          enrolltime: this.userInfo.additionInfo?.enrolltime ?? '',
          grade: this.userInfo.additionInfo?.grade ?? '',
          // classno: this.userInfo.additionInfo!.classno,
          // enrolltime: this.userInfo.additionInfo!.enrolltime,
          // grade: this.userInfo.additionInfo!.grade,
        })
          .then((res) => {
            this.$store.dispatch('setUserInfo').then(() => {
              this.$router.back()
            })
          })
          .catch((e) => {})
      } else {
        //班级保存
        updateInfo({
          username: this.userInfo.username,
          school: this.userInfo.school,
          department: this.userInfo.department,
          teachcourse: this.userInfo.teachcourse,
          stno: this.userInfo.stno,
          majors: this.userInfo.majors,
          classno: this.stnoNumber,
          enrolltime: this.userInfo.additionInfo?.enrolltime ?? '',
          grade: this.userInfo.additionInfo?.grade ?? '',
          // enrolltime: this.userInfo.additionInfo!.enrolltime,
          // grade: this.userInfo.additionInfo!.grade,
        })
          .then((res) => {
            this.$store.dispatch('setUserInfo').then(() => {
              this.$router.back()
            })
          })
          .catch((e) => {})
      }
    }
  }
  mounted() {
    if (this.$route.query.modify == 'name') {
      this.stnoNumber = this.userInfo.username
      this.title = i18n.t('Home.姓名') as string
      this.$setNavInfo({
        type: 'normal',
        title: this.title,
        showTitle: true,
      })
    } else if (this.$route.query.modify == 'depart') {
      this.stnoNumber = this.userInfo.department
      this.title = i18n.t('ktpMy.院系') as string
      this.$setNavInfo({
        type: 'normal',
        title: this.title,
        showTitle: true,
      })
    } else {
      const additionInfo = this.userInfo.additionInfo as any
      this.stnoNumber = additionInfo.classno ?? ''
      this.title = i18n.t('CourseHome.班级') as string
      this.$setNavInfo({
        type: 'normal',
        title: this.title,
        showTitle: true,
      })
    }
  }
}
